module.exports = __webpack_public_path__ + "tree.svg?50a082dd6bfcfe1a76532d5afe43bdb9";